import CONFIG from '../../../../config'
import MAYA from '../../../../maya_api'
import {getStore} from '../../../../main'
import {openTimeoutPopup} from '../../../../store/timer'

let timer = -1;
let lastTimeout = 0;

let timerLastTime = 0;
let timerCurrentTime = 0;

export function startTimer() {
  lastTimeout = Number.MAX_SAFE_INTEGER;
  timerCurrentTime = +new Date() / 1000;
  reset();
  routine();
}

export function tryReset() {
  if (!isTimeout()) reset();
}

export function reset() {
  timerLastTime = timerCurrentTime;
}

export function stop() {
  clearInterval(timer);
}

export function getCountdown() {
  return (Math.max(lastTimeout + CONFIG.INTERNAL_TIMEOUT - getTimeElapsed(), 0)).toFixed(0);
}

function isTimeout() {
  return getTimeElapsed() >= lastTimeout;
}

function getTimeElapsed() {
  const time = timerLastTime;
  if (time === 0) return 0;
  return (timerCurrentTime - time) || 0;
}

function routine() {
  clearInterval(timer);

  const store = getStore();

  timer = setInterval(async function() {
    timerCurrentTime = Math.round(+new Date() / 1000);

    if (getCountdown() == 0) {
      return await MAYA.logout();
    }

    if (isTimeout()) {
      await store.dispatch(openTimeoutPopup());
    }

    lastTimeout = CONFIG.TIMEOUT;
  }, 1000)
}


// WEBPACK FOOTER //
// ./src/components/shared/TimeoutOverlay/modules/timer.js